var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1250_2962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 14.6404C10.3259 14.9882 10.7148 15.2645 11.1441 15.4531C11.5734 15.6418 12.0344 15.7389 12.5 15.7389C12.9656 15.7389 13.4266 15.6418 13.8559 15.4531C14.2852 15.2645 14.6741 14.9882 15 14.6404L19 10.4577C19.663 9.76438 20.0355 8.82402 20.0355 7.84351C20.0355 6.863 19.663 5.92265 19 5.22932C18.337 4.53599 17.4377 4.14648 16.5 4.14648C15.5623 4.14648 14.663 4.53599 14 5.22932L13.5 5.75216",
    stroke: "#38CB89",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 10.4559C13.674 10.1081 13.285 9.83183 12.8558 9.6432C12.4265 9.45458 11.9655 9.35742 11.4999 9.35742C11.0343 9.35742 10.5733 9.45458 10.144 9.6432C9.71474 9.83183 9.32577 10.1081 8.99989 10.4559L4.99989 14.6386C4.33685 15.332 3.96436 16.2723 3.96436 17.2528C3.96436 18.2333 4.33685 19.1737 4.99989 19.867C5.66293 20.5603 6.56221 20.9498 7.49989 20.9498C8.43757 20.9498 9.33685 20.5603 9.99989 19.867L10.4999 19.3442",
    stroke: "#38CB89",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1250_2962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25.0963,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkGreen);
export default __webpack_public_path__ + "static/media/link-green.a08fb72aa355a855e011cfb5d4d718c2.svg";
export { ForwardRef as ReactComponent };